module.exports = __webpack_public_path__ + "static/media/A-Spades.ab7800e4.svg";